import { render } from "./Tm_footer.vue?vue&type=template&id=087699ec&ts=true"
import script from "./Tm_footer.vue?vue&type=script&lang=ts"
export * from "./Tm_footer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__